module.exports = __webpack_public_path__ + "b7e8e5dbcf85bb4317c5fcecb6b77a23.jpg";